import React from "react";
import Skill from "./Skill";
import { delay, motion } from "framer-motion";

const About = () => {
  const skills = [
    "HTML5",
    "CSS3",
    "Sass",
    "JavaScript",
    "ReactJS",
    "Illustrator",
    "Photoshop",
    "Figma",
    "XD",
  ];

  const textAnimation = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, delay: 0.3, ease: "easeInOut" } },
  };

  const skillContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1, 
      },
    },
  };

  const skillItem = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };


  return (
    <section id="about" className="container flex items-center m-auto md:mt-0 px-0 md:px-0">
      <div className="px-4 mt-6 md:mt-0 md:px-0 bg-background flex-row justify-center   md:flex md:justify-between items-center">
        {/* Skills */}
        <motion.div
          className=" md:h-[50%] md:flex md:flex-col md:justify-start md:w-1/2"
          variants={skillContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3 }}
        >
          <h3 className="text-2xl md:text-4xl font-semibold mb-6">I'm good with</h3>
          <div className="flex flex-wrap gap-4 md:gap-6 w-[100%] md:w-[55%]">
            {skills.map((skill, index) => (
              <motion.div key={index} variants={skillItem}>
                <Skill title={skill} />
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* About */}
        <motion.div
          className=" md:h-[50%] md:flex md:flex-col md:justify-start md:w-1/2 py-0 md:py-0 mt-12 "
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3 }}
          variants={textAnimation}
        >
          <h3 className="text-2xl md:text-4xl font-semibold mb-6">Get to Know Me!</h3>
          <div className="flex flex-col gap-4 text-base md:text-xl opacity-90">
            <motion.p variants={textAnimation}>
              I'm a user experience designer and front-end developer with over
              three years of experience. My background includes both corporate
              and freelance work.
            </motion.p>
            <motion.p variants={textAnimation}>
              I've worked in various areas of digital design, including
              front-end development, back-end development, graphic design, and
              UI/UX. I'm proud of every experience. My main focus these days is
              on building accessible user interfaces for my clients.
            </motion.p>
            <motion.p variants={textAnimation}>
              Design can wonderfully influence our decisions and emotions. It
              turns website visitors into your customers. So I'm here to help
              you with that.
            </motion.p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;
